import React, { useMemo } from 'react'
import {
    screenPocketsImages,
    pocketsSwingImages,
    cornerScreenPocketsImages,
  } from "../../initialValues/screens";
  import { useStore } from "../../store/store";

function useScreenPocketSelector(
    defaultPocketWide: () => void, 
    displayedPocketImg: string
) {
  const addToQuote = useStore((state) => state.addToQuote);

  const doorType = useStore((state) => state.quote.doorType);
  const screenPocket = useStore((state) => state.quote.screenPocket);

  const screenPocketVal =
    screenPocket && screenPocket.replace(" (upcharge applies)", "");

  const material = useStore((state) => state.quote.material);
  const cornerType = useStore((state) => state.quote.cornerType);

  const isCornerUnit = doorType?.includes("Corner");

  const handleClick = (label: string, type: string, disabled: boolean) => {
    if (disabled) return;

    const checked = label === screenPocket;

    const isDouble = type === "double"; //double pocket option, at least single pocket required

    if (checked) {
      if (isDouble && label === "Add Double Pocket") {
        defaultPocketWide();
      } else {
        addToQuote({ screenPocket: "" });
      }
    } else {
      addToQuote({ screenPocket: label });
    }
  };

  const filteredPocketImg = useMemo(() => {
    if (!displayedPocketImg || doorType === "Slider") return;

    if (isCornerUnit) {
      return cornerScreenPocketsImages.find(
        (img) =>
          img.label === displayedPocketImg && img.cornerType === cornerType,
      );
    }

    const images = doorType.includes("Bi-fold")
      ? screenPocketsImages
      : pocketsSwingImages;

    return images.find((img) => img.label === displayedPocketImg);
  }, [displayedPocketImg, doorType, cornerType]);

  return {
    filteredPocketImg,
    handleClick,
    material,
    screenPocketVal,
    isCornerUnit,
    screenPocket
  }
}

export default useScreenPocketSelector